import React, { memo, useState, useCallback, useEffect } from 'react';
import classNames from 'classnames';

import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './Category.module.less';
import { logging } from '../../actions/log';
// import residualImg from '../../static/residual.png';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ getActive, categoryList, showResidual }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const [active, setActive] = useState('all_zw');
  const [showcategoryList, setShowCategoryList] = useState([]);

  useEffect(() => {
    const temp = showResidual
      ? [
          { name: '全部', id: 'all_zw' },
          { name: '待清理残留项', id: 'residual' },
        ]
      : [{ name: '全部', id: 'all_zw' }];
    if (categoryList && categoryList.length === 1 && categoryList[0].id === '9999') {
      setShowCategoryList(temp);
    } else {
      setShowCategoryList([...temp, ...categoryList]);
    }
  }, [categoryList, showResidual]);

  const handleClick = useCallback(
    (item = 'all_zw') => {
      dispatch(
        logging({
          category: 'C',
          action: 'Mysofts_Classify',
          label: '',
          param2: {
            source: `Mysofts_Classify||${item === 'all_zw' ? '-1' : item}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );

      setActive(item);
      getActive(item);
      const el = document.getElementById('container_content');
      if (el) {
        el.scrollTo(0, 0);
      }
    },
    [logInfoData, getActive],
  );
  useEffect(() => {
    const target = showcategoryList.find(item => item.id === active);
    if (!target) {
      handleClick();
    }
  }, [showcategoryList]);
  if (!categoryList || categoryList.length < 1) {
    return <></>;
  }
  if (categoryList && categoryList.length === 1 && categoryList[0].id === '9999') {
    return <></>;
  }
  return (
    <>
      <div
        className={classNames(styles.category, {
          [styles.category_residual]: showResidual,
        })}
      >
        {showcategoryList.map((item, index) => {
          return (
            <React.Fragment key={item.id}>
              {index === 1 && showResidual && (
                <div
                  className={classNames(styles.item, styles.clear_item, styles.clear_item_text, {
                    [styles.clear_item_active]: active === 'residual',
                  })}
                  onClick={() => {
                    handleClick('residual');
                  }}
                  style={{ width: '103px' }}
                >
                  {item.name}
                </div>
              )}
              {(index !== 1 || !showResidual) && (
                <div
                  className={classNames(styles.item, { [styles.active]: item.id === active })}
                  onClick={() => {
                    handleClick(item.id);
                  }}
                >
                  {item.name}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
});
